import type { NarrowExposureConfig } from '@atlassian/post-office-context/narrow-exposure';

import type { PostOfficeMessageCreationType } from '../components/PostOfficeMessage';

type MessageLifecycleProps = {
	configSetId?: string;
	journeyId?: string;
	journeyTriggerId?: string;
	messageCreationType?: PostOfficeMessageCreationType;
	triggerId?: string;
	inAppNarrowExposureExperiment?: NarrowExposureConfig | null;
};

type PlacementMessageLifecycleFields = {
	configSetId?: string;
	journeyId?: string;
	journeyTriggerId?: string;
	messageCreationType?: string;
	triggerId?: string;
	inAppNarrowExposureExperiment?: NarrowExposureConfig | null;
};

type TransformMessageCreationTypeToPostOfficeMessageCreationTypeParams = {
	messageCreationType?: string;
};

const transformMessageCreationTypeToPostOfficeMessageCreationType = ({
	messageCreationType,
}: TransformMessageCreationTypeToPostOfficeMessageCreationTypeParams):
	| PostOfficeMessageCreationType
	| undefined => {
	if (messageCreationType === 'implicit' || messageCreationType === 'explicit') {
		return messageCreationType;
	}

	return undefined;
};

type TransformPlacementMessageToMessageLifecyclePropsParams = {
	message: PlacementMessageLifecycleFields | undefined;
};

export const transformPlacementMessageToMessageLifecycleProps = ({
	message,
}: TransformPlacementMessageToMessageLifecyclePropsParams): MessageLifecycleProps => ({
	configSetId: message?.configSetId,
	journeyId: message?.journeyId,
	journeyTriggerId: message?.journeyTriggerId,
	messageCreationType: transformMessageCreationTypeToPostOfficeMessageCreationType({
		messageCreationType: message?.messageCreationType,
	}),
	triggerId: message?.triggerId,
	inAppNarrowExposureExperiment: message?.inAppNarrowExposureExperiment,
});
